<script setup lang="ts"></script>

<template>
	<section id="about" class="about-section">
		<h2 class="about-section__title">О нас</h2>
		<div class="about-section__content-container">
			<div class="about-section__text-container">
				<div class="about-section__text">
					<p>
						Мы - компания, занимающаяся профессиональной перевозкой грузов из Китая в Россию, где
						расположены наши склады для хранения вашего груза. Предоставляем услуги для молодых
						компаний и для организаций с небольшими оборотами ДС.
					</p>
					<p>
						Мы займемся таможенным оформлением и подготовкой прочих документов, вам останется
						только получить товар.
					</p>
				</div>
				<div class="about-section__list">
					<div class="about-section__list-item">
						<div class="list-item__icon-container">
							<Icon name="local:weight" class="list-item__icon" aria-hidden="true" />
						</div>
						<div class="about-section__list-text">
							<span>Минимальный вес:</span>
							10кг
						</div>
					</div>
					<div>
						<div class="list-item__icon-container">
							<Icon name="local:coins" class="list-item__icon" aria-hidden="true" />
						</div>
						<div class="about-section__list-text">
							<span>Стоимость:</span>
							1200 ₽ / кг
						</div>
					</div>
					<div>
						<div class="list-item__icon-container">
							<Icon name="local:calendar-check" class="list-item__icon" aria-hidden="true" />
						</div>
						<div class="about-section__list-text">
							<span>Частота отгрузки:</span>
							2 раза в неделю
						</div>
					</div>
				</div>
			</div>
			<NuxtImg
				src="/images/about-section.png"
				alt="Доставка самолетом из Китая"
				densities="x1 x2"
				sizes="360px xs:800px md:1200px xl:408px"
				format="webp"
				class="about-section__image"
			/>
		</div>
	</section>
</template>

<style lang="scss" scoped>
	.about-section__title {
		font-size: var(--font-size-title);
		color: var(--color-tertiary);
		font-weight: 700;
		margin-bottom: 12px;
	}
	.about-section__content-container {
		display: grid;
		gap: 20px;
	}
	.about-section__text-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.about-section__text {
		margin-bottom: 20px;
		p:not(:last-child) {
			margin-bottom: calc(var(--font-size-text) * 1.2);
		}
	}
	.about-section__list {
		display: flex;
		flex-direction: column;
		gap: 15px;
	}
	.list-item__icon-container {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 32px;
		height: 32px;
		border-radius: 6px;
		background-color: var(--color-secondary);
		margin-bottom: 7px;
		.list-item__icon {
			color: var(--color-white);
			height: 24px;
			width: 24px;
		}
	}
	.about-section__list-text {
		span {
			font-weight: 700;
		}
	}
	.about-section__image {
		width: 100%;
		aspect-ratio: 1.7;
		border-radius: 50px;
		overflow: hidden;
		object-fit: cover;
	}

	@media (min-width: 1240px) {
		.about-section__title {
			margin-bottom: 15px;
		}
		.about-section__content-container {
			grid-template-columns: 1fr 408px;
			gap: 27px;
		}
		.about-section__text-container {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}
		.about-section__text {
			text-wrap: pretty;
			max-width: 690px;
			margin-bottom: 25px;
			p:not(:last-child) {
				margin-bottom: calc(var(--font-size-text) * 1.2);
			}
		}
		.about-section__list {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			gap: 0px;
		}
		.list-item__icon-container {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 32px;
			height: 32px;
			border-radius: 6px;
			background-color: var(--color-secondary);
			margin-bottom: 7px;
			.list-item__icon {
				color: var(--color-white);
				height: 24px;
				width: 24px;
			}
		}
		.about-section__list-text {
			span {
				font-weight: 700;
			}
		}
		.about-section__image {
			width: 408px;
			height: 240px;
			border-radius: 50px;
			aspect-ratio: auto;
		}
	}
</style>
